export const i18n_vi = {
  appfullname: "TRANG THÔNG TIN KHÁCH HÀNG",
  appfullnamecap: "TRANG THÔNG TIN KHÁCH HÀNG",
  appabbr: "CMS",
  appdashboardname: "Dashboard",

  appclientcap: "TRANG THÔNG TIN KHÁCH HÀNG",

  appaddress:
    "Tầng 20, Tòa nhà Phú Mỹ Hưng, 8 Hoàng Văn Thái, phường Tân Phú, Quận 7, Tp Hồ Chí Minh",

  // #Search enum
  contractnumber: "Số hợp đồng",

  // #Common
  username: "Tên đăng nhập",

  password: "Mật khẩu",

  changepassword: "Đổi mật khẩu",

  login: "Đăng nhập",

  register: "Đăng ký",

  relogin: "Đăng nhập lại",

  logout: "Đăng xuất",

  cancel: "Hủy",

  comments: "Ghi chú",

  actionlabel: "Thao tác",

  upload: "Tải lên",

  address: "Địa chỉ",

  email: "Thư điện tử",

  emailnot: "Không có thư điện tử",

  fullname: "Họ và Tên",

  payment: "Tiến hành thanh toán",

  currencyvalue: "đồng",

  currencyyearvalue: "đồng/năm",

  searchtitle: "Vùng tìm kiếm",

  searchkey: "Từ khóa tìm kiếm",

  searchconditionlabel: "Điều kiện tìm kiếm",

  issue: "Chấp nhận",

  reject: "Từ chối",

  picturefront: "CMND/Hộ chiếu mặt trước",

  picturebehind: "CMND/Hộ chiếu mặt sau",

  status: "Trạng thái",

  male: "Nam",

  female: "Nữ",

  clientname: "Tên khách hàng",

  description: "Ghi chú",

  clientinfo: "Thông tin cá nhân",

  relationship: "Mối quan hệ",

  no: "STT",

  searchFreelook: "Số hợp đồng/Số CMND",

  detailsinfo: "Thông tin chi tiết",

  cashbackinfo: "Thông tin hoàn phí",

  save: "Lưu lại",

  phone: "Số điện thoại",

  phonemobile: "Điện thoại di động",


  province: "Tỉnh / TP",

  district: "Quận / Huyện",

  ward: "Phường / Xã",

  dob: "Ngày sinh",

  gender: "Giới tính",

  idnumber: "CMND/CCCD/Hộ chiếu",

  iddate: "Ngày cấp",

  idplace: "Nơi cấp",

  idtype: "Loại giấy tờ",

  identification: "Giấy tờ tùy thân",

  paymentslip: "Giấy nộp tiền",

  // #Common date
  datefrom: "Từ ngày",

  dateto: "Đến ngày",

  dateapproved: "Ngày duyệt",

  datecreated: "Ngày tạo",

  // #icon
  iconadd: "Thêm",

  iconview: "Xem",

  iconedit: "Sửa",

  iconclone: "Sao chép",

  icondelete: "Xóa",

  iconback: "Trở lại",

  iconagree: "Đồng ý",

  // # Common message
  messagetitle: "Thông báo!",

  messageerrorcreatelabel: "Tạo mới không thành công",

  messageerrorupdatelabel: "Cập nhật không thành công",

  messageerrorupdateversionlabel:
    "Dữ liệu này đã được người dùng khác cập nhật",

  messageerrorcreateupdatelabel: "Tạo mới/cập nhật không thành công",

  messagesuccesscreatelabel: "Tạo mới thành công",

  messagesuccessupdatelabel: "Cập nhật thành công",

  messagesuccesssaveDraftlabel: "Lưu nháp thành công",

  messagesuccesssendrequestlabel: "Gửi yêu cầu thành công",

  messagesuccesssendrequesttoemaillabel: "Phiếu yêu cầu đã được gửi tới Email của Quý Khách",

  messagesuccessreturnlabel: "Trả về thành công",

  messagesuccessapprovelabel: "Phê duyệt thành công",

  messagesuccessassignlabel: "Phân công thành công",

  messagesuccessdeletelabel: "Xóa dữ liệu thành công",

  messagesuccessimportlabel: "Nhập dữ liệu thành công",

  messagesuccessvalidatelabel: "Kiểm tra dữ liệu thành công",

  messagesuccessuploadimage: " ảnh được tải lên thành công",

  messageconfirmdeletecontent: "Bạn muốn xóa dữ liệu này?",

  messageconfirmbackpagecontent: "Bạn muốn quay về trang trước?",

  messageconfirmtransferdepartment:
    "Bạn có chắc rằng đã lưu các dữ liệu thay đổi trước khi chuyển phòng ban khác?",

  messageconfirmissuecontent: "Bạn có chắc chắn muốn chấp nhận hợp đồng này?",

  messageconfirmrejectcontent: "Bạn có chắc chắn muốn từ chối hợp đồng này?",

  messagesuccesssavelabel: "Lưu thành công",

  messagesavefail: "Lưu thất bại",

  messageconfirmaddproducttoprocess:
    "Bạn có muốn thêm sản phẩm con của sản phẩm này?",

  messageerroractionlabel: "Thao tác không thành công",

  messageerrorpaymentcannot: "Không thể tiến hành thanh toán",

  messagedeletesuccess: "Xóa thành công",

  messagedeletefail: "Xóa thất bại",

  messagedocumentmandatory: "Tài liệu bắt buộc là",

  messageerrordepartmentexits: "Phòng ban này đã được thêm",

  messagedataempty: "Không có dữ liệu",

  messageerroruserexits: "Người dùng này đã được thêm",

  messageblankdob: "Vui lòng chọn ngày sinh",

  messageblankid: "Vui lòng nhập Số CMND/CCCD/Hộ chiếu",

  messageblankphone: "Vui lòng nhập Số điện thoại",

  messageinvalidphonestartnumber: "Số điện thoại bắt đầu là số 0",

  messageinvalidphonenumber: "Số điện thoại bao gồm 10 chữ số",

  messageinvalididnumber: "Số CMND/Hộ chiếu bao gồm 9 hoặc 12 chữ số",

  messageexistclient:
    "Thông tin CMND/Hộ chiếu hoặc Số điện thoại của bạn đã tồn tại",

  messagequestionreject1:
    "Quý khách không đủ điều kiện để tham gia gói bảo hiểm này",

  messagequestionreject2: "Xin chân thành cám ơn quý khách",

  messagequestionanswer: "Bạn vui lòng trả lời tất cả câu hỏi",

  messageblankname: "Vui lòng nhập Họ và Tên",

  messageblankaddress: "Vui lòng nhập địa chỉ",

  messageblankemail: "Vui lòng nhập địa chỉ email",

  messageblankproduct: "Vui lòng chọn gói sản phẩm",

  messageotptitle:
    "Mã OTP đã được gửi đến số điện thoại 0 Quý khách vui lòng kiểm tra tin nhắn để nhập mã chính xác Xin cảm ơn",

  messageotpinput: "Nhập OTP:",

  messageotpinvalid: "Mã OTP không đúng, vui lòng thử lại",

  messageotpinvalidmany:
    "Bạn đã nhập sai OTP nhiều lần Vui lòng kiểm tra hoặc nhấn Gửi lại OTP (lưu ý không quá 5 lần/ ngày)",

  messageotpnotsend: "Không gửi được tin nhắn OTP, vui lòng thử lại",

  messageblankfrontfile:
    "Vui lòng chọn hình ảnh mặt phía trước CMND/Hộ chiếu của bạn",

  messageblankbackfile:
    "Vui lòng chọn hình ảnh mặt phía sau CMND/Hộ chiếu của bạn",

  messageblankiddate: "Vui lòng chọn ngày cấp CMND/Hộ chiếu của bạn",

  messageblankcomments: "Vui lòng nhập vào ô ghi chú lý do từ chối",

  messageinvalidimagefile: "Vui lòng chọn file hình ảnh (bmp, jpg, jpeg, png)",

  messageinvalidemail: "Địa chỉ email không đúng định dạng",

  messagenotallowage:
    "Độ tuổi của quý khách không nằm trong phạm vi bảo hiểm của Công ty",

  messagechangestatus: "Vui lòng thay đổi trạng thái!",

  messageexistidnum:
    "Số CMND/Hộ chiếu này đã được đăng ký Vui lòng kiểm tra lại hoặc liên hệ với Phú Hưng Life để biết thêm thông tin",

  messageexistphone:
    "Số điện thoại này đã được đăng ký Vui lòng kiểm tra lại hoặc liên hệ với Phú Hưng Life để biết thêm thông tin",

  messageexistpayment:
    "Đã tồn tại 1 hợp đồng bảo hiểm với các thông tin liên quan nhưng chưa được thanh toán Vui lòng kiểm tra lại hoặc liên hệ với Phú Hưng Life để biết thêm thông tin",

  messageexiststatus_0:
    "Đã tồn tại 1 hợp đồng bảo hiểm với các thông tin liên quan Vui lòng kiểm tra lại hoặc liên hệ với Phú Hưng Life để biết thêm thông tin",

  messageexiststatus_1:
    "Đã tồn tại 1 hợp đồng bảo hiểm với các thông tin liên quan Vui lòng kiểm tra lại hoặc liên hệ với Phú Hưng Life để biết thêm thông tin",

  messagemustchecked:
    'Vui lòng chọn "Tôi đồng ý với các điều khoản và điều kiện sử dụng"',

  messageblanknationality: "Vui lòng nhập quốc gia",

  messageblankidplace: "Vui lòng nhập nơi cấp",

  messagedateerror: "Dữ liệu ngày tháng không đúng, vui lòng kiểm tra lại",

  messageblankpass: "Vui lòng nhập mật khẩu",

  messageblankpass_change: "Vui lòng nhập mật khẩu mới",

  messageblankpassretype: "Mật khẩu mới không giống nhau",

  messageblankpassmustnotsamewithcurpass: "Mật khẩu mới không được trùng với mật khẩu hiện tại",

  messagepleasefillallfields: "Vui lòng nhập tất cả dữ liệu",
  
  messagepasswrong: "Sai mật khẩu",

  messagepasschangefail:
    "Cập nhật mật khẩu không thành công Vui lòng kiểm tra lại",

  messagepasschangesuccess: "Cập nhật mật khẩu thành công",

  messagepasslenght: "Mật khẩu phải ít nhất 6 ký tự",

  messagebeneficiarynameblank: "Vui lòng nhập tên người thụ hưởng",

  messagebeneficiarydobblank: "Vui lòng nhập ngày sinh người thụ hưởng",

  messagerelationshipblank: "Vui lòng nhập mối quan hệ",

  messagebeneficiaryidblank: "Vui lòng nhập CMND/CCCD/Hộ chiếu",

  messagesendrequestfail: "Gửi yêu cầu thất bại Vui lòng thử lại",

  messagesendrequestfailsumassured:
    "Yêu cầu GQQLBH vượt mức cho phép nộp hồ sơ trực tuyến",

  messagepolicynotcorrect:
    "Dữ liệu hợp đồng bảo hiểm không chính xác hoặc hợp đồng của Quý khách không đủ điều kiện để tham gia chương trình",

  messagepaymentcancel: "Thanh toán đã bị hủy Vui lòng thanh toán lại",

  messagepaymentsuccess: "Thanh toán thành công",

  messageselectlife: "Chọn Người được bảo hiểm",

  messageselectaddtype: "Chọn loại thương tật",

  messagesendrequestfailsumassuredadd: "Số tiền yêu cầu GQQLBH Thương tật do tai nạn của Quý khách vượt quá 10 triệu đồng, vì vậy không đủ điều kiện nộp trực tuyến Vui lòng nộp hồ sơ tại các văn phòng kinh doanh của Công ty trên toàn quốc",

  messageselecthospital: "Chọn nơi điều trị",

  messagesendrequestfailsumassuredhi: "Số tiền yêu cầu GQQLBH Hỗ trợ chi phí nằm viện của Quý khách vượt quá 5 triệu đồng, vì vậy không đủ điều kiện nộp trực tuyến Vui lòng nộp hồ sơ tại các văn phòng kinh doanh của Công ty trên toàn quốc",

  messagefilesrequireempty: "Vui lòng tải lên các chứng từ liên quan",

  messagesendrequestmailfail: "Gửi mail yêu cầu thất bại",

  messagesendrequestmailsuccess: "Gửi mail yêu cầu thành công",

  // # Common error page
  errorpage: "Trang lỗi",

  erroraccesspage: "Không thể kết nối đến hệ thống, vui lòng thử lại sau!!!",

  errormessagegetdata: "Đã có lỗi xảy ra, vui lòng liên hệ PHL để được hỗ trợ. Xin cảm ơn.",

  errormessagenotfoundpolicy: "Không tìm thấy hợp đồng bảo hiểm tương ứng, liên hệ PHL để được hỗ trợ, xin cảm ơn.",

  errormessagenotfoundphone: "Số điện thoại không đúng với số đã đăng ký trước đây.",

  errormessagepolicyexpired: "Hợp đồng bảo hiểm của Quý khách đang bị mất hiệu lực.",

  errormessagewrongformatotp: "Sai định dạng OTP, vui lòng nhập lại",

  errormessageaction: "Thực thi lỗi, vui lòng tải lại trang!!!",

  errormessageserver: "Lỗi hệ thống, vui lòng nhập lại",

  errormessageloadimagefail: "Tải ảnh không thành công, vui lòng kiểm tra lại",

  errormessagesendrequestfail: "Gửi yêu cầu thất bại!",

  errorhint: "Ngay bây giờ, bạn có thể",

  errorhintbackroot: "quay về trang chủ",

  errorcode404title: "Lỗi! Trang không được tìm thấy",

  errorcode404content: "Chúng tôi không tìm thấy trang mà bạn đang tìm kiếm",

  errorcodecommontitle: "Lỗi! Hệ thống xảy ra lỗi",

  errorcodecommoncontent: "Vui lòng liên hệ quản trị viên để sửa lỗi này",

  errorcodecommondatatitle: "Lỗi! Hệ thống xảy ra lỗi dữ liệu",

  errorcodecommondatacontent:
    "Dữ liệu không được tìm thấy hoặc ai đó đã xóa nó Vui lòng liên hệ quản trị viên nếu cần thiết",

  invaliduserpassword: "Đăng nhập không thành công",

  errorcodemenuexits: "Mã danh mục đã tồn tại",

  errormessageaccessdenied: "Không có quyền truy cập trang này!",

  errormessagemissingfield: "Thiếu dữ liệu",

  errormessagerequirefield: "Vui lòng nhập đầy đủ dữ liệu!",

  errormessageinvalidemail: "Thư điện tử không đúng định dạng, vui lòng nhập lại",

  errormessagenotselect: "Vui lòng chọn thông tin cần điều chỉnh",

  errormessagecontactnotselect: "Vui lòng chọn Địa chỉ liên lạc/Địa chỉ thường trú/Số điện thoại cần thay đổi",

  errormessageprofilenotadd: "Vui lòng nhập thông tin cá nhân cần điều chỉnh",

  errormessagephonenotadd: "Vui lòng nhập số điện thoại liên lạc cần điều chỉnh",

  errormessagefrequencynotselect: "Vui lòng chọn Định kỳ đóng phí cần thay đổi",

  // # Common table
  columnactionlabel: "Thao tác",

  tablelengthMenulabel: "Hiển thị _MENU_ dòng",

  tableemptyTablelabel: "Không có dữ liệu",

  tableinfolabel: "Từ dòng _START_ đến _END_ của _TOTAL_ dòng",

  tablesearchlabel: "Tìm kiếm",

  tablezeroRecordslabel: "Không tìm thấy dữ liệu phù hợp",

  tableloadingRecordslabel: "Xin hãy chờ",

  tableprocessinglabel: "Đang xử lý",

  tablepagelabel: "Trang ",

  tablepagefirst: "← Đầu",

  tablepagelast: "Cuối →",

  // #Menu
  menuhome: "Trang chủ",

  menuregistration: "Thông tin cơ bản",

  menuproduct: "Sản phẩm bảo hiểm",

  menuquestion: "Câu hỏi kiểm tra sức khỏe",

  menuaddition: "Cập nhật thông tin",

  menupayment: "Thanh toán",

  menuecancer: "Bảo hiểm bệnh ung thư",

  menucommitment: "Cam kết",

  menufreelook: "Hủy hợp đồng trong 21 ngày",

  menumycontract: "Hợp đồng của tôi",

  menumydetails: "Chi tiết hợp đồng",

  menucontact: "Liên hệ",

  // #Buttons
  buttonviewdetail: "Xem gói bảo hiểm",

  buttonproductdetail: "Gói bảo hiểm của tôi",

  buttonregistry: "Đăng ký ngay",

  buttoncontinue: "Tiếp tục",

  buttonprevious: "Trở lại",

  buttonresendotp: "Gửi lại OTP",

  buttonverifyotp: "Xác thực OTP",

  buttonsendotp: "Gửi tin nhắn xác thực OTP",

  buttonsearch: "Tìm kiếm",

  buttonrepay: "Thanh toán lại",

  buttonsubmit: "Gửi yêu cầu",

  buttonfinish: "Hoàn tất",

  buttoncheck: "Kiểm tra",

  buttonverify: "Xác thực",

  buttonbenefitadd: "Thêm vào bảng yêu cầu",

  buttonnext: "Tiếp theo",

  buttonclose: "Đóng",

  buttonagree: "Đồng ý",

  buttonnew: "Tạo mới",

  buttonnewform: "Tạo đơn mới",

  // #Question
  questionlist: "Bảng câu hỏi",

  question: "Câu hỏi",

  yes: "Có",

  no: "Không",

  answer: "Trả lời",

  // #product
  productname: "Tên sản phẩm",

  productinfo: "Thông tin sản phẩm",

  productterm: "Thời hạn đóng phí",

  productfrequence: "Định kỳ đóng phí",

  producttermrisk: "Thời hạn bảo hiểm",

  productsumassured: "Số tiền bảo hiểm",

  product: "Sản phẩm",

  // # Validator default
  NotEmptyjavalangString: "Giá trị bắt buộc nhập",

  datavalidateidlength: "Độ dài tối đa là 0",

  datavalidateemail: "Không đúng định dạng Email",

  datavalidateurl: "Đường dẫn",

  datavalidatedate: "Định dạng ngày tháng",

  datavalidatedateISO: "Date ISO",

  datavalidatenumber: "Chỉ nhập định dạng số",

  datavalidatephonenumberzero: "Số điện thoại bắt đầu là số 0",

  datavalidaterangelength: "giá trị phải từ 0 đến 1 ký tự",

  // #Bank info
  bankowner: "Tên chủ tài khoản",

  bankname: "Tên ngân hàng",

  bankaccount: "Số tài khoản",

  bankoffice: "Chi nhánh",

  // #Client
  clientnationality: "Quốc tịch",

  clientchangepass: "Thay đổi mật khẩu",

  clientpassold: "Mật khẩu cũ",

  clientpassnew: "Mật khẩu mới",

  clientpassretype: "Nhập lại mật khẩu",

  // #Email
  emailissurancepolicysubject: "[Bệnh ung thư] - Hợp đồng bảo hiểm điện tử",

  emailrejectpolicysubject: "[Bệnh ung thư] - Thư từ chối bảo hiểm",

  emailpaymentconfirn:
    "[Bệnh ung thư] - Hồ sơ yêu cầu bảo hiểm và xác nhận thanh toán",

  emailverifyotp: "[Bệnh ung thư] - Mã OTP xác nhận số điện thoại",

  emailnoticenewpolicysubject: "[Bệnh ung thư] - Thư thông báo hợp đồng mới",

  // #Policy
  policylife: "Người được bảo hiểm",

  policyowner: "Bên mua bảo hiểm",

  policynumber: "Số hợp đồng",

  policynum: "Số hợp đồng bảo hiểm",


  policybeneficiary: "Người thụ hưởng",

  policylifeinfo: "Thông tin người được bảo hiểm",

  policybeneficiaryinfo: "Thông tin người thụ hưởng",

  policyfrequency1: "Năm",

  policyfrequency2: "Nửa năm",

  policyfrequency4: "Quý",

  policylist: "Danh sách hợp đồng",

  policydetails: "Chi tiết hợp đồng",

  policypremium: "Phí bảo hiểm",

  policyissue: "Đã duyệt",

  policyreject: "Đã từ chối",

  policycreate: "Đang chờ duyệt",

  policypaymentdescription: "Khách hàng 0 thanh toán phí bảo hiểm năm đầu",

  policyissued:
    "Chuc mung quy khach Hop dong bao hiem - Benh ung thu cua quy khach chinh thuc duoc phe duyet Xin vui long kiem tra file dinh kem trong Email Cam on quy khach da chon mua san pham bao hiem cua Cong ty Co Phan BHNT Phu Hung",

  policyrejected:
    "Cam on quy khach da chon mua san pham bao hiem cua Cong ty Co Phan BHNT Phu Hung, rat tiec yeu cau bao hiem cua ban da bi tu choi Chung toi da gui thu tu choi den dia chi email ma quy khach da dang ky",

  policypaymentsuccess:
    "Chúc mừng quý khách Quý khách đã thanh toán thành công Chúng tôi sẽ phản hồi sớm nhất cho quý khách trong vòng 24h Cảm ơn quý khách!",

  policyapplicationnumber: "Số đơn đăng ký",

  policyedit: "Cập nhật hợp đồng bảo hiểm",

  policystatus: "Tình trạng hợp đồng",

  policyinfo: "Thông tin hợp đồng",

  policyconfirmsuccess: "Chúc mừng Quý khách đã kích hoạt thành công tài khoản",

  policyconfirmfail: "Rất tiếc! Tài khoản chưa được kích hoạt thành công",

  policyissueddate: "Ngày phát hành",

  policyeffecteddate: "Ngày hiệu lực",

  policypaymentlast: "Ngày đóng phí gần nhất",

  policypremiumlast: "Phí đóng gần nhất",

  policypaidToDate: "Ngày đến hạn đóng phí",

  // #POS
  posmenu: "Cập nhật thông tin hợp đồng",

  posrequest: "Yêu cầu thay đổi thông tin liên quan hợp đồng bảo hiểm",

  posverifypolicyinfo: "Xác thực thông tin",

  poschangecontact: "Thay đổi thông tin liên lạc",

  poschangeinformation: "Điều chỉnh thông tin cá nhân",

  poschangefrequency: "Thay đổi định kỳ đóng phí",

  posapplyall:
    "Cập nhật cho tất cả các hợp đồng mà Quý khách là bên mua bảo hiểm",

  posapplyfor: "Áp dụng đồng thời cho địa chỉ thường trú.",

  posaddresscontact: "Địa chỉ liên lạc",

  posaddressresident: "Địa chỉ thường trú",

  posaddchange: "Thêm thay đổi",

  possubmit: "Gửi yêu cầu",

  poschangefor: "Điều chỉnh cho",

  posfileupload: "Tải lên chứng từ liên quan",

  postermtitle:
    "Tôi, Bên mua bảo hiểm (BMBH) yêu cầu điều chỉnh Hợp đồng bảo hiểm theo các hạng mục nêu trên và đồng ý rằng:",

  posterm1:
    "Tôi cam kết những thông tin trên là sự thật và hoàn toàn chịu trách nhiệm về những thông tin do mình cung cấp",

  posterm2:
    "Tôi đồng ý cho phép Công ty xác nhận, sử dụng, lưu trữ, xử lý, chuyển giao và cung cấp thông tin của tôi cho bên thứ ba liên quan khi cần thiết Trong trường hợp phát sinh lỗi của bên thứ ba trong quá trình chuyển giao, xử lý thông tin, Công ty sẽ được loại trừ mọi trách nhiệm, nghĩa vụ liên quanTheo đó, khi NĐBH/NĐBH bổ sung/NTH tròn 18 tuổi có yêu cầu thay đổi quyền bảo mật thông tin vui lòng thông báo cho Phú Hưng Life bằng văn bản",

  posterm3:
    "Yêu cầu điều chỉnh này là một phần không thể tách rời của hợp đồng nói trên và điều chỉnh này chỉ có hiệu lực khi được Phú Hưng Life chấp thuận bằng văn bản trong thời gian Người được bảo hiểm (NĐBH) còn sống",

  posterm4:
    "Tôi cam đoan tình trạng sức khỏe của BMBH/ NĐBH/ NĐBH bổ sung không có gì thay đổi so với lần bổ sung gần nhất cho Công ty Trong thời gian chờ quyết định thẩm định, nếu BMBH/ NĐBH/ NĐBH bổ sung có bất kỳ sự thay đổi nào về tình trạng sức khỏe, bệnh tật hoặc về nghề nghiệp, nơi cư trú cũng như các thông tin liên quan khác, BMBH sẽ thông báo các thay đổi này cho Phú Hưng Life để làm cơ sở thẩm định",

  posreason: "Vui lòng chọn lý do",

  pleaseaccept: "Vui lòng chọn \"Tôi cam kết và đồng ý\"",

  // #PAYMENT
  paymentapplication: "Thanh toán phí bảo hiểm đầu tiên",
  paymenttitle: "Thanh toán phí hợp đồng bảo hiểm",

  paymentpolicycheck: "Xác thực thông tin hợp đồng bảo hiểm",

  paymentpolicyinfo: "Thông tin hợp đồng bảo hiểm",

  paymentsuccesslabel: "Thanh toán phí hợp đồng bảo hiểm số 0 thành công",

  paymentmethod: "Phương thức thanh toán",

  payment: "Thanh toán",

  paymentonline: "Thanh toán trực tuyến",

  paymentmethodoffice:
    "Nhận tiền mặt tại Quầy Dịch vụ Khách hàng (áp dụng cho số tiền dưới 20 triệu)",

  paymentmethodpremium: "Đóng phí bảo hiểm",

  paymentmethodtransfer: "Chuyển vào tài khoản cá nhân",

  paymentmethodbank: "Nhận tiền mặt tại ngân hàng",

  paymentoffice: "Văn phòng nhận tiền",

  paymentofficedecs:
    "Với phương thức nhận quyền lợi bảo hiểm tại Quầy Dịch vụ Khách hàng, Quý khách có thể làm thủ tục nhận tiền sau 3 ngày làm việc kể từ ngày phát hành thư thông báo kết quả GQQLBH Quý khách kiểm tra thông tin cá nhân và chọn văn phòng nhận tiền",

  paymentreceiver: "Họ tên người nhận tiền",

  paymentpolicy: "Số HĐ được đóng phí",

  paymentpolicycheck: "Xác thực thông tin hợp đồng bảo hiểm",
  paymentinfo: "Thông tin thanh toán",

  paymentpolicydecs:
    "Với phương thức nhận quyền lợi bảo hiểm qua hình thức đóng phí bảo hiểm, Số tiền chi trả quyền lợi bảo hiểm (nếu có) sẽ được chuyển vào hợp đồng được đóng phí (với điều kiện cùng Bên mua bảo hiểm)",
  paymentpolicyterm: "Thanh toán phí bảo hiểm định kỳ",
  paymentpremiumcheck: "Vui lòng nhập phí bảo hiểm > 0.",
  paymentpremiumnote1: "Vui lòng nhập số tiền chẵn ngàn đồng(VD: 1.234.000 đồng).",
  paymentpremiumnote2: "Số tiền lẻ dưới 1 ngàn đồng(1.000 đồng) sẽ được Công ty làm tròn để thanh toán phí bảo hiểm.",
  paymenttransferfailed: "Không thể chuyển đến trang thanh toán.",
  paymenttransferdecs:
    "Với phương thức nhận quyền lợi bảo hiểm chuyển vào tài khoản cá nhân, Quý khách có thể nhận tiền sau 3 ngày làm việc kể từ ngày phát hành thư thông báo kết quả GQQLBH Lưu ý nếu tên chủ tài khoản khác bên mua bảo hiểm, Quý khách vui lòng đính kèm giấy ủy quyền",

  paymentbankdecs:
    "Với phương thức nhận quyền lợi bảo hiểm nhận tiền mặt tại ngân hàng, Quý khách có thể làm thủ tục nhận tiền sau 3 ngày làm việc kể từ ngày phát hành thư thông báo kết quả GQQLBH",

  paymentnote: "Lưu ý",

  paymentnote1:
    "Trong trường hợp Quý khách lựa chọn phương thức nhận tiền mặt tại Quầy Dịch vụ Khách hàng của Công ty hoặc Ngân hàng, Quý khách vui lòng lưu ý mang theo CMND/CCCD (bản gốc còn hiệu lực)",

  paymentnote2:
    "Trong trường hợp, thông tin Người nhận tiền khác với Bên mua bảo hiểm, Quý khách vui lòng gửi kèm Giấy ủy quyền (bản gốc) tại các văn phòng kinh doanh",

  // #CLAIM
  claimtitle: "Giải quyết quyền lợi BH",

  claimregister: "Trang yêu cầu giải quyết quyền lợi bảo hiểm trực tuyến ECLAIMS",

  claimregistercomments: "(Hiện tại áp dụng cho Quyền lợi Hỗ trợ chi phí nằm viện với số tiền yêu cầu cho mỗi đợt nằm viện không quá 5 triệu đồng và/hoặc Quyền lợi Thương tật do tai nạn với số tiền yêu cầu không quá 10 triệu đồng)",
  claimregistercomments1: "(Hiện tại áp dụng cho ",
  claimregistercomments2: "Quyền lợi Hỗ trợ chi phí nằm viện",
  claimregistercomments3: "với số tiền yêu cầu cho mỗi đợt nằm viện không quá 5 triệu đồng và/hoặc",
  claimregistercomments4: "Quyền lợi Thương tật do tai nạn",
  claimregistercomments5: " với số tiền yêu cầu không quá 10 triệu đồng)",
  claimpolicycheck: "Xác thực thông tin hợp đồng",

  claimpersonalinfo: "Thông tin cá nhân",

  claimpersonalinsured: "Người được bảo hiểm",

  claimpersonalinsuredextra: "Người được bảo hiểm bổ sung",

  claimpersonalrequest: "Người yêu cầu giải quyết QLBH",

  claimbenefitselect: "Chọn quyền lợi bảo hiểm",

  claimbenefithi: "Quyền lợi Hỗ trợ chi phí nằm viện",

  claimbenefitadd: "Quyền lợi Thương tật do tai nạn",

  claimbenefitaddtype: "Loại thương tật",

  claimnature: "Loại quyền lợi",

  claimdateeffective: "Ngày hiệu lực",

  claimdateevent: "Ngày xảy ra sự kiện bảo hiểm",

  claimdateadmission: "Ngày nhập viện",

  claimdatedischarge: "Ngày ra viện",

  claimdayrequest: "Số ngày yêu cầu",

  claimdayhospital: "Số ngày nằm viện",

  claimdiagnose: "Chẩn đoán",

  claimtreatmentplace: "Nơi điều trị",

  claimtreatmentadd: "Thêm đợt điều trị",

  claimreport: "Tường trình tại nạn (nêu rõ thời gian, địa điểm, nguyên nhân, diễn biến)",

  claimnoteotp11: "Nếu không thể xác thực OTP, Quý khách có thể tạo Đơn yêu cầu giải quyết quyền lợi bảo hiểm dạng PDF",

  claimnoteotp12: ", sau đó in ra, ký tên và gửi kèm chứng từ liên quan tại các văn phòng kinh doanh của Công ty trên toàn quốc",

  claimnoteotp2: "Trường hợp Quý khách thay đổi số điện thoại, vui lòng cập nhật số điện thoại mới trước khi tiến hành đăng ký và nộp hồ sơ trực tuyến",

  claimnoteotp31: "Quý khách có thể chọn truy cập trang để tạo",

  claimnoteotp32: "và gửi về Công ty hoặc đến trực tiếp tại Văn phòng kinh doanh của Công ty để hoàn tất thủ tục thay đổi",

  claimnoteemail1: "Quý khách vui lòng nhập địa chỉ thư điện tử cá nhân chính xác, Công ty sẽ sử dụng để liên hệ với Quý khách trong suốt quá trình tiếp nhận & giải quyết hồ sơ yêu cầu giải quyết quyền lợi bảo hiểm Trong trường hợp Quý khách không có thư điện tử, Quý khách vui lòng truy cập trang để tạo",

  claimnoteemail2: ", sau đó in, ký tên và gửi kèm chứng từ liên quan tại các văn phòng kinh doanh của Công ty trên toàn quốc",

  claimpolicy: "HĐBH tham gia",

  claimnotbenefitselect: "Vui lòng chọn quyền lợi bảo hiểm",

  claimreviewprintpdf: "Xem và tải đơn yêu cầu GQQL",

  claimfilesupload: "Tải hình ảnh chứng từ gốc",

  claimhospitalcheckout: "Giấy ra viện",

  claimmedicalinpatientlist: "Bảng kê chi phí khám chữa bệnh nội trú",

  claimmedicalother: "Chứng từ y tế khác",

  claimfilmxray: "Phim X-Quang/ MRI/ CT",

  claimfilmxrayguide: "(Hướng dẫn chụp hình ảnh phim)",

  claimfilmresult: "Kết quả đọc phim bằng văn bản",

  claimapplicationform: "Đơn yêu cầu giải quyết QLBH",

  claimother: "Thông tin bảo hiểm khác",

  claimassured1:
    "Để hoàn tất thao tác yêu cầu GQQLBH trực tuyến, Quý khách vui lòng đọc và chọn đồng ý các điều khoản bên dưới:",

  claimassured: "Tôi cam kết và đồng ý:",

  // #claimassured2:'Cung cấp đầy đủ, chính xác các thông tin đã kê khai và chịu trách nhiệm về tính chính xác của các thông tin này
  claimassured2:
    "Tôi cam kết rằng tất cả nội dung trong Đơn này là đầy đủ, đúng sự thật, không bỏ sót nội dung quan trọng nào và hoàn toàn chịu trách nhiệm trước pháp luật về tính xác thực của những thông tin nêu trên Để có đủ cơ sở thẩm định, tôi sẵn sàng cung cấp các hồ sơ khác khi công ty yêu cầu",

  // #claimassured3:'Cho phép Công ty được chuyển giao các thông tin cá nhân do Bên mua bảo hiểm/ Người được bảo hiểm cung cấp, cũng như các thông tin khác liên quan đến Hợp đồng bảo hiểm cho bên thứ ba với mục đích giải quyết chi trả quyền lời lợi bảo hiểm, phòng chống trục lợi bảo hiểm Việc chia sẻ thông tin này sẽ tiếp tục có hiệu lực kể cả trong trường hợp quan hệ hợp đồng bảo hiểm giữa Bên mua bảo hiểm và Công ty chấm dứt
  claimassured3:
    "Tôi đồng ý ủy quyền Công ty liên hệ và thu thập, xử lý mọi thông tin về Người được bảo hiểm/ Bên mua bảo hiểm từ các bác sĩ được phép hành nghề, bác sĩ ngành y, bệnh viện, phòng khám hoặc các sơ sở y tế liên quan, công ty bảo hiểm hoặc các cơ quan, tổ chức hoặc cá nhân khác có hồ sơ hoặc biết về Người được bảo hiểm / Bên mua bảo hiểm hoặc sức khoẻ của Người được bảo hiểm / Bên mua bảo hiểm Bản copy của phần ủy quyền này có giá trị như bản gốc Trong quá trình giải quyết quyền lợi bảo hiểm, Công ty có quyền chuyển giao các thông tin trên cho các Bên thứ ba (Bên tái bảo hiểm, các bệnh viện, phòng khám hoặc cơ sở y tế liên quan, các bên cung cấp dịch vụ hỗ trợ cho Công ty,…) để xử lý, phân tích nhằm phục vụ cho mục đích giải quyết quyền lợi bảo hiểm Nếu có bất kỳ thiệt hại nào phát sinh do lỗi của Bên thứ ba, Công ty sẽ được miễn trừ mọi trách nhiệm, nghĩa vụ liên quan",

  claimassured4:
    "Trong một số trường hợp cần thiết, Công ty giữ quyền yêu cầu khách hàng bổ sung hồ sơ gốc",

  messagepolicynotbenefit:
    "Hợp đồng bảo hiểm 0 không có sản phẩm có các Quyền lợi bảo hiểm Hỗ trợ chi phí nằm viện và Thương tật do tai nạn để nộp hồ sơ yêu cầu giải quyết QLBH trực tuyến",

  messagepolicynotcorrectpolicy:
    "Số hợp đồng bảo hiểm của BMBH không đúng Quý khách vui lòng kiểm tra và nhập lại Xin cảm ơn",

  messagepolicynotcorrectidnumber1:
    "Số CMND/CCCD của BMBH không đúng với số hợp đồng đã đăng ký Quý khách vui lòng kiểm tra và nhập lại Trường hợp Quý khách thay đổi số CMND/ CCCD, vui lòng cập nhật số CMND/ CCCD mới bằng cách truy cập trang để tạo ",

  messagepolicynotcorrectidnumber2:
    "và gửi về Công ty hoặc đến trực tiếp tại Văn phòng kinh doanh của Công ty hoàn tất thủ tục thay đổi trước khi tiến hành đăng ký và nộp hồ sơ yêu cầu giải quyết QLBH trực tuyến Xin cảm ơn",

  messagepolicynotcorrectphone1:
    "Số điện thoại của BMBH không đúng với số hợp đồng đã đăng ký Quý khách vui lòng kiểm tra và nhập lại Trường hợp Quý khách thay đổi số điện thoại, vui lòng cập nhật số điện thoại mới bằng cách truy cập trang để tạo ",

  messagepolicynotcorrectphone2:
    "và gửi về Công ty hoặc đến trực tiếp tại Văn phòng kinh doanh của Công ty hoàn tất thủ tục thay đổi trước khi tiến hành đăng ký và nộp hồ sơ yêu cầu giải quyết QLBH trực tuyến Xin cảm ơn",

  messagedateduplicate:
    "Ngày nằm viện và ra viện không được trùng với đợt điều trị đã thêm",

  messagebeneefitterhi:
    "Quyền lợi Hỗ trợ chi phí nằm viện đã bị chấm dứt hiệu lực nên không thể nộp hồ sơ qua eClaims Nếu sự kiện bảo hiểm xảy ra trong thời gian Quyền lợi bảo hiểm còn hiệu lực, Quý khách vui lòng nộp hồ sơ yêu cầu tại các văn phòng kinh doanh của Công ty trên toàn quốc để được xem xét",

  messagebeneefitteradd:
    "Quyền lợi Thương tật do tai nạn đã bị chấm dứt hiệu lực nên không thể nộp hồ sơ qua eClaims Nếu sự kiện bảo hiểm xảy ra trong thời gian Quyền lợi bảo hiểm còn hiệu lực, Quý khách vui lòng nộp hồ sơ yêu cầu tại các văn phòng kinh doanh của Công ty trên toàn quốc để được xem xét",

  messagebeneefitlapsehi:
    "Quyền lợi Hỗ trợ chi phí nằm viện đang bị mất hiệu lực nên không thể nộp hồ sơ qua eClaims Nếu sự kiện bảo hiểm xảy ra trong thời gian Quyền lợi bảo hiểm còn hiệu lực, Quý khách vui lòng nộp hồ sơ yêu cầu tại các văn phòng kinh doanh của Công ty trên toàn quốc để được xem xét",

  messagebeneefitlapseadd:
    "Quyền lợi Thương tật do tai nạn đang bị mất hiệu lực nên không thể nộp hồ sơ qua eClaims Nếu sự kiện bảo hiểm xảy ra trong thời gian Quyền lợi bảo hiểm còn hiệu lực, Quý khách vui lòng nộp hồ sơ yêu cầu tại các văn phòng kinh doanh của Công ty trên toàn quốc để được xem xét",

  messagepolicylapse:
    "Hợp đồng đang bị mất hiệu lực nên không thể nộp hồ sơ qua eClaims Nếu sự kiện bảo hiểm xảy ra trong thời gian Quyền lợi bảo hiểm còn hiệu lực, Quý khách vui lòng nộp hồ sơ yêu cầu tại các văn phòng kinh doanh của Công ty trên toàn quốc để được xem xét",

  messagepolicyter:
    "Hợp đồng đã bị chấm dứt hiệu lực nên không thể nộp hồ sơ qua eClaims Nếu sự kiện bảo hiểm xảy ra trong thời gian Quyền lợi bảo hiểm còn hiệu lực, Quý khách vui lòng nộp hồ sơ yêu cầu tại các văn phòng kinh doanh của Công ty trên toàn quốc để được xem xét",

  messagepolicynotallow:
    "Hợp đồng không thể nộp hồ sơ qua eClaims Vui lòng liên hệ Hotline để được hỗ trợ",

  messagedatenotmetadd:
    "Sự kiện bảo hiểm xảy ra trước ngày hiệu lực của Quyền lợi Thương tật do tai nạn Vì vậy, Công ty rất tiếc phải thông báo không có khoản thanh toán nào đối với sự kiện này",

  messagedatenotmethi:
    "Sự kiện bảo hiểm xảy ra trước ngày hiệu lực của Quyền lợi Hỗ trợ chi phí nằm viện Vì vậy, Công ty rất tiếc phải thông báo không có khoản thanh toán nào đối với đợt nằm viện này",

  messagesupplementsubmitsuccess:
    "Cảm ơn Quý khách đã tin cậy và đồng hành cùng Công ty Bảo hiểm nhân thọ Phú Hưng Quý khách đã thao tác thành công bước bổ sung chứng từ theo yêu cầu Công ty sẽ phản hồi tiến trình xử lý hồ sơ cho Quý khách trong thời gian sớm nhất",

  messagesupplementalready:
    "Hồ sơ yêu cầu giải quyết quyền lợi bảo hiểm của Quý khách đang được xử lý hoặc đã hoàn tất Để biết thêm chi tiết vui lòng liên hệ Hotline để được hỗ trợ",

  formtiltepos: "Yêu cầu thay đổi thông tin cá nhân khách hàng",

  formtilteclaim: "Đơn yêu cầu giải quyết quyền lợi bảo hiểm",

  claimcompanyname: "Tên công ty",

  claiminsuredother:
    "Người được bảo hiểm có được bảo hiểm bởi công ty khác không? ",

  claimotheradd: "Thêm công ty khác",

  claimsupplementtitle: "Bổ sung chứng từ (hình ảnh)",

  claimsupplementnote:
    "* Chỉ chấp nhận định dạng file: PNG, JPG, JPEG, PDF Các định dạng khác sẽ tự động bỏ qua",

  claimclaimno: "Số hồ sơ yêu cầu",

  claimclaimnoinfo: "Thông tin hồ sơ yêu cầu",

  linkClaim: "https://i-form.phuhunglife.com/Claim/Clm02",

  loading: "Đang tải",
  access: "Truy cập",
  // Customer
  titleLoginCustomer1: "Cổng Thông Tin",
  titleLoginCustomer2: "Khách Hàng",
  usernamecustomer: "CMND/CCCD/Hộ Chiếu",
  sendotpsuccess: "Gửi mã OTP thành công!!!",
  resendotp: "Gửi lại mã OTP",

  welcometitle: "Chào mừng khách hàng ",

  homepagetitle1: "Phú Hưng Life",
  homepagetitle2: "Vì Bạn, Vì Cuộc Sống Vững Bền",
  homepagetitle3: "Chào mừng bạn đến với Cổng thông tin Khách hàng.",
  homepagetitle4: "Cảm ơn khách hàng ",
  homepagetitle5: " đã tin tưởng,",
  homepagetitle6: "tín nhiệm và đồng hành cùng Bảo hiểm Nhân thọ Phú Hưng",

  customerinfo: "Thông Tin Khách Hàng",
  policycustomer: "Hợp Đồng Bảo Hiểm",
  onlinepaymentcustomer: "Thanh Toán Trực Tuyến",
  settlementofinsurancebenefitcustomer: "Giải quyết quyền lợi Bảo hiểm",
  posrequestcustomer: "Gửi yêu cầu trực tuyến",
  customerchangepassword: "Đổi mật khẩu",
  laName: "Bên Mua Bảo Hiểm",
  email: "Email",
  email1: "Thư điện tử",
  tier: "Hạng: ",
  listpolicy: "Danh sách hợp đồng bảo hiểm",
  countpolicy1: "Bạn có ",
  countpolicy2: " Hợp đồng",
  mainproduct: "Tên sản phẩm chính",
  datevalid: "Ngày hiệu lực",
  periodicinsurancepremium: "Phí bảo hiểm định kỳ",
  customerpolicynumber: "Số hợp đồng bảo hiểm: ",
  effect: "Hiệu Lực",
  noeffect: "Không Hiệu Lực",
  pressdetail: "Bấm xem chi tiết",
  return: "Quay lại",
  relationpo: "Mối quan hệ với BMBH",
  relationbo: "Mối quan hệ với NĐBH",
  beneficiaryrate: "Tỉ lệ thụ hưởng",
  customerstatus: "Tình trạng",
  datepolicy: "Thời hạn HĐ/ Thời hạn BH",
  changelanguage: "Đổi ngôn ngữ thành công!!!",
  componentname: "Sản phẩm chính",
  benefitInsurance: "Quyền lợi bảo hiểm bổ trợ",


  errorexpiredotp: "Mã OTP đã quá hạn. Quý khách vui lòng lấy lại mã OTP khác",
  errorcountotp: "Bạn đã nhập sai OTP nhiều lần. Vui lòng kiểm tra hoặc nhấn Gửi lại OTP (lưu ý không quá 5 lần/ ngày).",
  missfield: "Vui lòng nhập đầy đủ thông tin",
  accept: "Xác nhận",
  recreatepassword: "Tạo lại mật khẩu",
  alreadyhasaccount: "Đã có tài khoản?",
  activeaccount: "Kích hoạt tài khoản",
  forgetpassword: "Quên mật khẩu?",
  active: "Kích hoạt",
  createaccount: "Tạo tài khoản",
  posphonecontact: "Điện thoại liên lạc",
  phoneconfirmation: "Xác nhận thuê bao",
  guideposiform: "Hướng dẫn sử dụng trang i-Form",
  viewhelpposclip: "  Xem đoạn clip hướng dẫn:",
  herepos: "tại đây.",
  viewchangecontactpos: "Yêu cầu thay đổi thông tin liên lạc ",
  viewchangepersonalpos: "Yêu cầu thay đổi thông tin cá nhân khách hàng ",
  viewchangefrequencypos: "Yêu cầu thay đổi định kỳ đóng phí ",
  viewhelpposdoc: " Xem tài liệu hướng dẫn:",
  identityrequiredpos: "Hồ sơ đính kèm yêu cầu thay đổi: Giấy tờ tùy thân (CMND/CCCD/Hộ chiếu); Giấy nộp tiền (Phiếu thu).",
  presentpassword: "Mật khẩu hiện tại",
  newpassword: "Mật khẩu mới",
  renewpassword: "Nhập lại mật khẩu mới"
};

